import { render, staticRenderFns } from "./email_index.vue?vue&type=template&id=1b5f5a5a&"
import script from "./email_index.vue?vue&type=script&lang=js&"
export * from "./email_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5f5a5a')) {
      api.createRecord('1b5f5a5a', component.options)
    } else {
      api.reload('1b5f5a5a', component.options)
    }
    module.hot.accept("./email_index.vue?vue&type=template&id=1b5f5a5a&", function () {
      api.rerender('1b5f5a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mailboxer/email_index.vue"
export default component.exports